import {
  Avatar,
  BottomNavigation,
  Button,
  CardHeader,
  Checkbox,
  CircularProgress,
  CssBaseline,
  FormControlLabel,
  Grid,
  IconButton,
  Paper,
  Radio,
  RadioGroup,
} from "@mui/material";
import { Box } from "@mui/system";
import React, {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useSnackbar } from "notistack";
import MultiUpload from "../../../../components/MultipleUpload";
import CaptureUpload from "../../../../components/CaptureV2";
import MenuAppBar from "../../../../components/Appbar";
import CustomInputAutocomplete from "../../../../components/Autocomplete/AutoCompleteBank";

import { FiFileText } from "react-icons/fi";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { CustomerContext } from "../../../../Contexts/CustomerContext";
import { useNavigate, useParams } from "react-router-dom";
import { IncredoBankList } from "../../../../util/constants";
import { getChequeData, updateCustomerBankDetails } from "../../../../api";
import useCustomer from "../../../../hooks/useCustomer";
import { GlobalContext } from "../../../../Contexts/GlobalContext";
import LoadingOver from "../../../../components/LoadingOver";
import { LoanContext } from "../../../../Contexts/LoanJourneyContext";
import { updateBankDetails } from "../../../../api/agent";
import PennyDrop from "../../../../components/PennyDrop";
import { isBlank, isIFSCValid } from "../../../../validations/fieldValidations";

const radioStyle = {
  color: "#274384",
  "&.Mui-checked": {
    color: "#274384",
  },
};

const labelStyle = {
  color: "gray",
};

const BankDetails = forwardRef((props, ref) => {
  const { enqueueSnackbar } = useSnackbar();
  const { application_id } = useParams();

  const [isLoading, setLoading] = useState(false);
  const [pUploadError, setPError] = useState(false);
  const [pErrorTxt, setPErrorTxt] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [banks, setBanks] = useState([]);
  const [pennyState, setPennyState] = useState({
    show: false,
    status: "pending",
  });

  const { journeyState } = useContext(LoanContext);
  const [journeyData, setJourneyData] = journeyState;

  const { bottomNav } = useContext(GlobalContext);
  const [bankDetails, setBankDetails] = useState({ cheques: [] });

  const navigate = useNavigate();

  const isValid = async () => {
    let valid = true;
    let errors = {
      beneficiary_name: isBlank(journeyData?.beneficiary_name || ""),
      bank_name: isBlank(journeyData?.bank_name || ""),
      bank_code: isBlank(journeyData?.bank_code || ""),
      account_type: isBlank(journeyData?.account_type || ""),
      account_number: isBlank(journeyData?.account_number || ""),
      ifsc_code: await isIFSCValid(journeyData?.ifsc_code,journeyData?.bank_name),
      cash_credit:
        journeyData?.account_type === "Cash_Credit_Account_Overdraft_Account"
          ? isBlank(journeyData?.credit_over_limit || "")
          : "",
    };

    console.log(errors);
    setFieldErrors(errors);

    for (let i in errors) {
      if (errors[i].length > 0) {
        valid = false;
      }
    }

    return valid;
  };

  const handleSubmit = async () => {
    setLoading(true);
    if (await isValid()) {
      let payload = {
        bank_beneficiary_name: journeyData?.beneficiary_name,
        bank_name: journeyData?.bank_name,
        bank_code: journeyData?.bank_code,
        bank_account_type: journeyData?.account_type,
        bank_account_number: journeyData?.account_number,
        bank_ifsc_code: journeyData?.ifsc_code,
        cash_credit: journeyData?.credit_over_limit || "",
      };

      console.log(payload);
      // setLoading(false);
      // return;

      setPennyState({
        ...pennyState,
        show: true,
      });

      try {
        let { data } = await updateBankDetails(payload, application_id, false);
        if (data?.status) {
          if (!data?.pennyDropFailed) {
            setPennyState({
              ...pennyState,
              show: true,
              status: "success",
            });
          } else {
            enqueueSnackbar("Penny Drop failed!", {
              variant: "error",
            });
            setPennyState({
              ...pennyState,
              show: false,
            });
            navigate("/onboard/bank-accounts/" + application_id);
          }
        }
      } catch (error) {
        setPennyState({
          ...pennyState,
          show: false,
        });
        enqueueSnackbar(error?.response?.message, {
          variant: "error",
        });
        navigate("/onboard/bank-accounts/" + application_id);
      }
    }
    setLoading(false);
  };

  const removeItem = (index) => {
    setBankDetails((st) => ({
      ...st,
      cheques: bankDetails.cheques.filter((val, i) => {
        if (i !== index) return val;
      }),
    }));
  };

  // useEffect(() => {
  //   BanksList.forEach((val) => {
  //     banks.push(val.bank);
  //   });
  //   setBanks(banks);
  // }, []);

  useEffect(() => {
    console.log(pennyState);
  }, [pennyState]);

  return (
    <>
      <Box className="kyc-wrapper" sx={{ pb: 7, pt: 5 }} ref={ref}>
        <MenuAppBar home={false} noBack={true} draft={true} />
        <CssBaseline />
        <div className="main-wrapper">
          <Grid item xs={12} sm={12}>
            <label className="form-label mt-3">
              Beneficiary Name <span className="mand-star">*</span>
            </label>
            <input
              type="text"
              className="form-input w-100 px-3"
              required
              placeholder="Beneficiary Name"
              name="beneficiary-name"
              autoComplete="family-name"
              value={journeyData.beneficiary_name}
              onChange={(e) => {
                setJourneyData((st) => ({
                  ...st,
                  beneficiary_name: e.target.value,
                }));
              }}
              onKeyUp={
                (e) => {}
                // setFieldErrors((st) => ({
                //   ...st,
                //   email: isEmailValid(e.target.value),
                // }))
              }
            />
            <span className="error">{fieldErrors.beneficiary_name}</span>
          </Grid>

          <Grid item xs={12} sm={12}>
            <label className="form-label mt-3">
              Bank Name <span className="mand-star">*</span>
            </label>

            <CustomInputAutocomplete
              options={IncredoBankList}
              onChange={(val) => {
                // setFieldErrors((prev) => ({ ...prev, bank: "" }));
                setJourneyData((prev) => ({
                  ...prev,
                  bank_name: val?.name,
                  bank_code: val?.code,
                }));
                // let bank = BanksList.find((el) => el.bankname === val);
                // setIfsc(bank?.ifsc);
              }}
            />

            <span className="error">{fieldErrors.bank_name}</span>
          </Grid>

          <Grid item xs={12} sm={12} className="pt-0 mt-4">
            <label className="form-label">
              Bank Account Type
              <span className="mand-star">*</span>
            </label>
            <RadioGroup
              // ref={refs.is_aadhaar_property_owned}
              className="mb-1 ps-3"
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              value={journeyData.account_type}
              onChange={(e) => {
                setJourneyData({
                  ...journeyData,
                  account_type: e.target.value,
                });
              }}
            >
              <FormControlLabel
                value={"savings"}
                control={<Radio sx={radioStyle} />}
                label={
                  <span style={{ fontSize: "10px" }}>Savings Account</span>
                }
                sx={labelStyle}
              />

              <FormControlLabel
                value={"current"}
                control={<Radio sx={radioStyle} />}
                label={
                  <span style={{ fontSize: "10px" }}>Current Account</span>
                }
                sx={labelStyle}
              />

              <FormControlLabel
                value={"Cash_Credit_Account_Overdraft_Account"}
                control={<Radio sx={radioStyle} />}
                label={
                  <span style={{ fontSize: "10px" }}>
                    Cash Credit Account/Overdraft Account
                  </span>
                }
                sx={labelStyle}
              />
            </RadioGroup>

            <span className="error">{fieldErrors.account_type}</span>
          </Grid>

          {journeyData?.account_type ===
            "Cash_Credit_Account_Overdraft_Account" && (
            <Grid item xs={12} sm={12}>
              <label className="form-label mt-4">
                Cash Credit / Overfdraft Limit{" "}
                <span className="mand-star">*</span>
              </label>
              <input
                type="text"
                className="form-input w-100 px-3"
                required
                placeholder="Cash Credit / Overfdraft Limit"
                name="credit-limit"
                autoComplete="family-name"
                value={journeyData.credit_over_limit}
                onChange={(e) => {
                  setJourneyData((st) => ({
                    ...st,
                    credit_over_limit: e.target.value,
                  }));
                }}
                onKeyUp={
                  (e) => {}
                  // setFieldErrors((st) => ({
                  //   ...st,
                  //   email: isEmailValid(e.target.value),
                  // }))
                }
              />
              <span className="error">{fieldErrors.cash_credit}</span>
            </Grid>
          )}

          <Grid item xs={12} sm={12}>
            <label className="form-label mt-3">
              Account Number <span className="mand-star">*</span>
            </label>
            <input
              type="text"
              className="form-input w-100 px-3"
              required
              placeholder="Your Account number"
              name="account-number"
              autoComplete="family-name"
              value={journeyData.account_number}
              onChange={(e) => {
                if (e.target.value !== "" && !/^\d+$/.test(e.target.value)) {
                  return false;
                }
                setJourneyData((st) => ({
                  ...st,
                  account_number: e.target.value,
                }));
              }}
              onKeyUp={
                (e) => {}
                // setFieldErrors((st) => ({
                //   ...st,
                //   email: isEmailValid(e.target.value),
                // }))
              }
            />
            <span className="error">{fieldErrors.account_number}</span>
          </Grid>
          <Grid item xs={12} sm={12}>
            <label className="form-label mt-3">
              IFSC Code <span className="mand-star">*</span>
            </label>
            <input
              type="text"
              className="form-input w-100 px-3"
              required
              placeholder="Your IFSC code"
              name="pdf-password"
              autoComplete="family-name"
              value={journeyData.ifsc_code}
              maxLength={11}
              onChange={(e) => {
                setJourneyData((st) => ({
                  ...st,
                  ifsc_code: e.target.value?.toUpperCase(),
                }));
              }}
              onKeyUp={
                (e) => {}
                // setFieldErrors((st) => ({
                //   ...st,
                //   email: isEmailValid(e.target.value),
                // }))
              }
            />
            <span className="error">{fieldErrors.ifsc_code}</span>
          </Grid>
        </div>

        <Paper className="paper-bottom" elevation={3} ref={bottomNav}>
          <BottomNavigation style={{ height: "auto" }}>
            <div className="button-wrapper w-100">
              <Button
                className="btn-submit"
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mb: 2 }}
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <CircularProgress
                      className="me-2 mb-1"
                      size={20}
                      style={{ color: "white" }}
                    />
                    Loading
                  </>
                ) : (
                  "Confirm and Proceed"
                )}
              </Button>
            </div>
          </BottomNavigation>
        </Paper>
      </Box>
      {pennyState?.show && (
        <PennyDrop
          status={pennyState?.status}
          onClick={() => {
            navigate("/onboard/bank-accounts/" + application_id);
          }}
        />
      )}
    </>
  );
});

export default BankDetails;
